"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@tenantAuth/success",
  ERROR: "@@tenantAuth/error",
  LOGIN: "@@tenantAuth/login",
  LOGOUT: "@@tenantAuth/logout",
  RESET: "@@tenantAuth/reset",
  DETAILS: "@@tenantAuth/details",
  REFRESH_TOKEN: "@@tenantAuth/refresh-token",
  LOCKED_OUT: "@@tenantAuth/locked-out",
  SSO: "@@tenantAuth/sso",
  USER_LATEST_DETAIL: "@@tenantAuth/user-latest-detail"
};
exports.actionTypes = actionTypes;